import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HcaAddComponent } from './hca-add/hca-add.component';
import { HcaDetailsComponent } from './hca-details/hca-details.component';
import { HcaListComponent } from './hca-list/hca-list.component';
import { HcaMainComponent } from './hca-main/hca-main.component';
import { AuthGuard } from '../../../../shared/_guards/auth.guard';

const routes: Routes = [
  { path: 'hca-management', component: HcaMainComponent, canActivate: [AuthGuard],   
  children: [
    { path: '', pathMatch: 'full', component: HcaListComponent },
    { path: 'edit/:id', pathMatch: 'full', component: HcaDetailsComponent, canActivate: [AuthGuard]},
    { path: 'add', component: HcaAddComponent, canActivate: [AuthGuard]},
  ]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
exports: [RouterModule]
})
export class HotelChainManagementRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/components/admin/lsa-admin/hotel-chain-management/hotel-chain-management-routing.module.ts